module.exports = "/_next/static/images/WantToRetainCustomers-sm@2x-e2f15a139826b0693fee9a0b64294468.png";